import { sortBy } from "lodash";

import { getMedicalTypeName } from "@teamprevent/common/customMedicalTypes/model";

import { MedicalTypeId } from "../healthSurveillance";
import { CustomMedicalType } from "../healthSurveillance/models";
import { ImmunisationForCase } from "../immunisation/models";
import { CaseType } from "../model";

export interface OhCaseBaseModel {
    caseType?: string;
    medicalTypes?: MedicalTypeId[];
    immunisations?: ImmunisationForCase[];
}

export const getCaseInformation = (ohCase: OhCaseBaseModel, customMedicalTypes: CustomMedicalType[] | undefined) => {
    switch (ohCase.caseType) {
        case CaseType.HEALTH_SURVEILLANCE:
            const ohCaseMedicalTypeIds: MedicalTypeId[] = ohCase?.medicalTypes ?? [];
            const ohCaseMedicalTypeNames = ohCaseMedicalTypeIds.map(o => getMedicalTypeName(customMedicalTypes, o));
            return sortBy(ohCaseMedicalTypeNames).join(", ");
        case CaseType.IMMUNISATION:
            return sortBy(ohCase.immunisations, [imm => imm.name.toLowerCase()], "name").map(i => i.name).join(", ");
        default:
            return null;
    }
};
